import { RSAA } from "redux-api-middleware";
import config from "config";
import _ from "lodash";
import { formatToIsoWithUtc } from "services/UtilityService";

export const updateListState = (payload) => ({
  type: "UPDATE_BLACKLIST_LIST_STATE",
  payload,
});

export const resetError = () => ({
  type: "RESET_BLACKLIST_ERROR",
});


const filterModification = (filtered) =>
  _.cloneDeep(filtered)
    .map((filter) => {
      if (
        (filter.id === "creationDate" || filter.id === "lastModifiedDate") &&
        Array.isArray(filter.value)
      ) {
        const [start, end] = filter.value;
        return {
          ...filter,
          value: [
            start ? formatToIsoWithUtc(start) : null,
            end ? formatToIsoWithUtc(end) : null,
          ],
        };
      }
      return filter;
    })
    .filter((f) => {
      if (f.value == null) return false;
      if (Array.isArray(f.value)) return f.value.some((v) => v);
      return f.value !== "";
    });

export const fetchBlacklistedContacts = (
  page = 0,
  pageSize = 15,
  filtered = []
) => {
  const filteredDeepCopy = filterModification(filtered);

  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/blacklisted-contacts/list`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ page, pageSize, filtered: filteredDeepCopy }),
      types: [
        {
          type: "FETCH_BLACKLISTED_CONTACTS_REQUEST",
          payload: { listState: { page, pageSize, filtered } },
        },
        {
          type: "FETCH_BLACKLISTED_CONTACTS_SUCCESS",
          payload: async (_action, _state, res) => {
            const response = await res.json();
            return {
              data: response.data,
              totalCount: response.totalCount,
              currentPage: page,
              pageSize,
              filtered,
            };
          },
        },
        "FETCH_BLACKLISTED_CONTACTS_FAILURE",
      ],
    },
  };
};
